import { render, staticRenderFns } from "./ImgUpload.vue?vue&type=template&id=34578adc&scoped=true&"
import script from "./ImgUpload.vue?vue&type=script&lang=ts&"
export * from "./ImgUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ImgUpload.vue?vue&type=style&index=0&id=34578adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34578adc",
  null
  
)

export default component.exports